<script>
import { AccountInfoStore } from "../stores";

let accountInfo = {}
AccountInfoStore.subscribe((data) => {accountInfo = data})

accountInfo.loginStatus = false
AccountInfoStore.set(accountInfo)

localStorage.setItem("sugoi_username", "");
localStorage.setItem("sugoi_password", "");
localStorage.setItem("sugoi_coins", "");
localStorage.setItem("sugoi_accessToken", "");

import {push, pop, replace} from "svelte-spa-router"

replace("/")

</script>
